








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalBox extends Vue {
  @Prop({}) readonly width!: any;
  @Prop({}) readonly height!: any;

  created() {
    this.ToggleBodyOverFlow(true);
  }

  destroyed() {
    this.ToggleBodyOverFlow(false);
  }

  public ToggleBodyOverFlow(value: boolean) {
    const el = document.body;
    if (value) {
      el.style.overflow = "hidden";
    } else {
      el.style.overflow = "auto";
    }
  }
}
